var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetric1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#C4E9FD",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 39.5C23.0633 39.5 22.8766 39.5273 22.6984 39.5852C21.6859 39.9141 20.6211 40.125 19.5 40.125C18.3789 40.125 17.3141 39.9141 16.3008 39.5852C16.1227 39.5273 15.9367 39.5 15.75 39.5C10.9016 39.5 6.97422 43.4438 7 48.2984C7.01094 50.35 8.69766 52 10.75 52H28.25C30.3023 52 31.9891 50.35 32 48.2984C32.0258 43.4438 28.0984 39.5 23.25 39.5ZM19.5 37C23.6422 37 27 33.6422 27 29.5C27 25.3578 23.6422 22 19.5 22C15.3578 22 12 25.3578 12 29.5C12 33.6422 15.3578 37 19.5 37ZM53.25 12H23.25C21.182 12 19.5 13.7383 19.5 15.8742V19.5C21.3297 19.5 23.0234 20.0297 24.5 20.8906V17H52V39.5H47V34.5H37V39.5H31.0438C32.5359 40.8039 33.6313 42.5258 34.1445 44.5H53.25C55.318 44.5 57 42.7617 57 40.6258V15.8742C57 13.7383 55.318 12 53.25 12Z",
    fill: "#003AD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 40,
    fill: "white",
    transform: "translate(7 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric1);
export default __webpack_public_path__ + "static/media/metric1.1fd809b4c6f63117fdfd9bf434f86f04.svg";
export { ForwardRef as ReactComponent };